import React, { useEffect, useState } from 'react';
import Button from '../../components/Button'
import {
    Container,
    Resume,
    Details,
    Text,
    CheckboxContainer,
    TitleParagraph,
    TextRegulation,
    CheckboxDiv,
    LabelCheckbox
} from './styles'

import { FiMapPin } from "react-icons/fi"
import { HiOutlineKey, HiOutlineChevronDown } from "react-icons/hi";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Formik, Field, Form } from 'formik';
import InputMask from "react-input-mask";
import { Checkbox } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useApp } from "../../contexts/AppContext";
import { setConductorCarAction } from "../../contexts/reducers/cars/actions";
import format from "date-fns/format";
import { ResumeCar } from 'components/Resume';
import { LoaderSmall } from "../../components/Loader";

export function CarConductor() {

    const { carState, carDispatch } = useApp()
    const { car, datesSearchCar } = carState
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    },[])


    if (!car) return <Navigate to="/loja/search-result-cars" />

    if (loading) return <LoaderSmall />

    return (
        <Container>
            <Resume>Resumo da reserva</Resume>

            <Details>
                <HiOutlineKey size={22} /> Detalhes
            </Details>
            <Text>
                <p>Locadora</p>
                <p>{car?.company?.name}</p>
            </Text>
            <Text>
                <p>Categoria</p>
                <p>{car?.car?.category}</p>
            </Text>
            <Text>
                <p>Adicionais</p>
                <p>
                    {car.car?.hasAirConditioning && <span>AC</span>}
                    {car.car?.transmission && <span>{car.car?.transmission}</span>}
                    {car.car?.numberOfDoors && <span>{car.car?.numberOfDoors} Portas</span>}
                    {car.car?.numberOfBags && <span>{car.car?.numberOfBags} malas</span>}
                </p>
            </Text>
            <Text>
                <p>Inclusos</p>
                <p>
                    { car.fareSummary?.carRateIncludedItems.map((item, index) =>
                            <span key={index}>{item.description}</span>
                    )}
                </p>
            </Text>

            <Details>
                <FiMapPin size="22"/> Retirada
            </Details>
            <Text>
                <p>Data</p>
                <p> {format(datesSearchCar?.startDate, "dd/MM/yyyy HH:mm")}</p>
            </Text>
            <Text>
                <p>Local</p>
                <p>
                    {car?.pickupLocation?.company?.name} - {car?.pickupLocation?.address?.street}
                </p>
            </Text>

            <Details>
                <FiMapPin size="22"/>
                Devolução
            </Details>
            <Text>
                <p>Data </p>
                <p>{format(datesSearchCar?.endDate, "dd/MM/yyyy HH:mm")}</p>
            </Text>
            <Text>
                <p>Local</p>
                <p>
                    {car?.dropoffLocation?.company?.name} - {car?.dropoffLocation?.address?.street}
                </p>
            </Text>

            <Formik
                enableReinitialize={true}
                initialValues={{
                    firstName: "",
                    lastName: "",
                    document: "",
                    birthDate: "",
                    gender: "",
                    cell_phone: "",
                    phone: "",
                    checkTerms: 'off'
                }}
                onSubmit={async (values) => {
                    await new Promise((r) => setTimeout(r, 500));
                    carDispatch(setConductorCarAction(values))
                    navigate("/loja/checkout-travel/car");
                }}
            >
                {({values, setFieldValue}) => (
                    <Form>
                        <div className="mt-5">
                            <Resume>Dados do Condutor</Resume>
                            <div className="row gy-3 mt-1 mb-3 ">
                                <div className="col-12">
                                    <Field
                                        name="firstName"
                                        placeholder="Primeiro nome"
                                        className="form-control form-control-custom border-custom"
                                        required
                                    />
                                </div>
                                <div className="col-12">
                                    <Field
                                        name="lastName"
                                        placeholder="Último sobrenome"
                                        className="form-control form-control-custom border-custom"
                                        required
                                    />
                                </div>
                                <div className="col-6">
                                    <InputMask
                                        mask="999.999.999-99"
                                        onChange={(e) => setFieldValue(`document`, e.target.value)}
                                        className="form-control form-control-custom border-custom"
                                        maskChar={null}
                                        placeholder="CPF"
                                        value={values.document}
                                        required
                                    />
                                </div>

                                <div className="col-6">
                                    <InputMask
                                        mask="99/99/9999"
                                        maxLength={10}
                                        onChange={(e) => setFieldValue(`birthDate`, e.target.value)}
                                        className="form-control form-control-custom border-custom"
                                        maskChar={null}
                                        placeholder="Data de nascimento"
                                        value={values.birthDate}
                                        required
                                    />
                                </div>

                                <div className="col-6">
                                    <InputMask
                                        mask={"(99) 9999-9999"}
                                        maskChar={null}
                                        onChange={(e) => setFieldValue(`phone`, e.target.value)}
                                        className="form-control form-control-custom border-custom"
                                        placeholder="Telefone"
                                        value={values.phone}
                                        required
                                    />
                                </div>
                                <div className="col-6">
                                    <InputMask
                                        mask={"(99) 99999-9999"}
                                        maskChar={null}
                                        onChange={(e) => setFieldValue(`cell_phone`, e.target.value)}
                                        className="form-control form-control-custom border-custom"
                                        placeholder="Celular"
                                        value={values.cell_phone}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <CheckboxContainer>
                            <Field
                                className="custom-radio"
                                type="radio"
                                name="gender"
                                id="male"
                                value="male"
                                required
                            />
                            <label htmlFor="male">Masculino</label>
                        </CheckboxContainer>
                        <CheckboxContainer>
                            <Field
                                className="custom-radio"
                                type="radio"
                                name="gender"
                                id="female"
                                value="female"
                                required
                            />
                            <label htmlFor="female">Feminino</label>
                        </CheckboxContainer>
                        <CheckboxContainer>
                            <Field
                                className="custom-radio"
                                type="radio"
                                name="gender"
                                value=""
                                required
                            />
                            <label htmlFor="female">Não informar</label>
                        </CheckboxContainer>

                        <div>
                            <TitleParagraph>
                                Veja abaixo os requisitos necessários para a locação do veículo. A veracidade destas
                                informações
                                será conferida no momento da retirada do automóvel.
                            </TitleParagraph>

                            <div className="py-4">
                                <AiOutlineInfoCircle size={26}/>
                            </div>

                            <div className="d-flex align-items-center justify-content-between gap-2" data-bs-toggle="collapse"
                                 data-bs-target="#collapseInfo" aria-expanded="false" aria-controls="collapseInfo"
                            >
                                <Resume>
                                    Informações importantes
                                </Resume>

                                <HiOutlineChevronDown  size={24} />
                            </div>

                            <div className="collapse" id="collapseInfo">
                                <div className="mt-4">
                                    <TextRegulation>
                                        <p>Para resgate de locações de veículos em território nacional, o condutor deve possuir habilitação válida há mais de dois anos. É obrigatório a apresentação da Carteira Nacional de Habilitação (CNH) válida, no nome do condutor. A locação é permitida apenas para motoristas maiores de 21 (vinte e um) anos. Poderá ser necessário que o condutor apresente cartão de crédito com limite mínimo exigido pela locadora, para fins de pré-autorização de débito em garantia a eventuais danos, multas ou avarias decorrentes da utilização do veículo. A locadora será a única responsável por tal pré-autorização. Eventuais problemas relacionados à pré-autorização deverão ser solucionados diretamente com a locadora.</p>

                                        <p>Para resgate de locações de veículos em território internacional, o condutor deve possuir habilitação válida há mais de dois anos. Além da carteira de habilitação deverá ser apresentado passaporte válido, ou outro documento de identificação aceito de acordo com a legislação local. Para locações na Europa, é exigida a apresentação da Permissão Internacional para Dirigir (PID). A idade mínima para locação de carro no exterior varia de 21 (vinte e um) a 25 (vinte e cinco) anos de idade. As locadoras poderão cobrar taxas adicionais para condutores menores de 25 (vinte e cinco) anos de idade. Referidas taxas deverão ser pagas diretamente às locadoras. Poderá ser necessário que o condutor apresente cartão de crédito com limite mínimo exigido pela locadora, para fins de pré-autorização de débito em garantia a eventuais danos, multas ou avarias decorrentes da utilização do veículo. A locadora será a única responsável por tal pré-autorização. Eventuais problemas relacionados à pré-autorização deverão ser solucionados diretamente com a locadora.</p>

                                        <p>Equipamentos adicionais (cadeirinha de bebê, GPS, entre outros) e Taxas One Way (local de retirada do veículo diferente do local de devolução) podem ser solicitados às locadoras e serão pagos no local da retirada do veículo em moeda – nacional ou estrangeira, conforme o caso. O veículo alugado deve ser devolvido com a mesma quantidade de combustível recebida quando retirado da locadora (exceto quando esse item estiver incluído no plano e constar em seu voucher).</p>

                                        <p>A empresa locadora, o tipo e categoria do veículo e o nome do condutor constarão no voucher que será enviado por e-mail pelo Programa e deverá ser apresentado no respectivo estabelecimento comercial no momento da retirada do veículo.</p>
                                    </TextRegulation>
                                </div>
                            </div>
                        </div>

                        <CheckboxDiv>
                            <LabelCheckbox>
                                <div>
                                    <Checkbox
                                        color="default"
                                        required
                                        onChange={(e) => setFieldValue('checkTerms', e.target.value)}
                                    />
                                </div>
                                <div className="paragraph">
                                    Declaro que li e aceito os Termos e Condições de uso bem como as Políticas de Alterações e Cancelamentos dos Serviços.
                                </div>
                            </LabelCheckbox>
                        </CheckboxDiv>

                        <div className="my-5">
                            <Resume className="border-bottom w-100 pb-4">
                                Resumo
                            </Resume>
                            <ResumeCar />
                        </div>
                        <div className="mt-4 mb-5">
                            <Button type="submit">CONTINUAR</Button>
                        </div>
                    </Form>
                )}
            </Formik>

        </Container>
    )
}
